
        var result = require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--13-0!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/postcss-loader/index.js??ref--13-2!../../../../../../../../node_modules/sass-loader/index.js??ref--13-3!../../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--13-4!../../../../../../../../node_modules/import-glob-loader/index.js!./domain-configuration.component.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-item/domain-configuration/domain-configuration.component.scss
// module id = 2171
// module chunks = 0